"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const styles_1 = require("@material-ui/core/styles");
const styles = (theme) => (0, styles_1.createStyles)({
    centered: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        padding: theme.spacing(3)
    },
    pointsEarnedDetails: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        paddingLeft: theme.spacing(2),
        [theme.breakpoints.down('sm')]: {
            paddingLeft: 0
        }
    },
    titleText: {
        paddingBottom: theme.spacing()
    },
    newPointsSection: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        padding: theme.spacing(3),
        paddingLeft: theme.spacing(6),
        paddingRight: theme.spacing(6),
        borderRadius: '6px',
        backgroundColor: theme.palette.grey[200],
        [theme.breakpoints.down('sm')]: {
            flexDirection: 'column',
            paddingLeft: theme.spacing(2),
            paddingRight: theme.spacing(2)
        }
    },
    confirmationMessage: {
        [theme.breakpoints.down('sm')]: {
            textAlign: 'center'
        }
    },
    button: {
        paddingTop: theme.spacing() + 2,
        paddingBottom: theme.spacing() + 2,
        paddingLeft: theme.spacing(6),
        paddingRight: theme.spacing(6)
    },
    content: {
        width: '38em',
        [theme.breakpoints.down('xs')]: {
            width: '24.1em'
        }
    },
    dialogContent: {
        padding: 0
    },
    dialogBackground: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: theme.spacing(4)
    },
    cardBackground: {
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        padding: theme.spacing(2),
        [theme.breakpoints.down('xs')]: {
            width: '100%'
        }
    },
    redeemSuccessModalActions: {
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        padding: theme.spacing(2)
    },
    redeemSuccessText: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2)
    },
    downloadContainer: {
        width: '100%',
        display: 'flex',
        justifyContent: 'flex-end',
        marginTop: theme.spacing(2)
    },
    downloadIcon: {
        cursor: 'pointer'
    },
    text: {
        marginLeft: theme.spacing(2),
        marginRight: theme.spacing(2),
        marginTop: theme.spacing(),
        wordBreak: 'break-all'
    },
    title: {
        marginLeft: theme.spacing(2),
        marginRight: theme.spacing(2),
        marginBottom: theme.spacing(2),
        marginTop: theme.spacing()
    }
});
exports.default = styles;
//# sourceMappingURL=RedeemModalConfirmationStyle.js.map